


















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ComponentIntalentTesting extends Vue {
  // Props
  @Prop({ type: [Boolean, Number, String], default: false })
  size: false | number | string;

  @Prop({ type: Boolean, default: false })
  height: false;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/spinners/inlearno/component.vue